import React from 'react';
import { View } from 'react-native';
import Typography from 'src/components/Text/Text';
import Checkbox from 'src/components/Checkbox/Checkbox';
import Button from 'src/components/Button/Button';
import TourWrapper from 'src/components/TourWrapper/TourWrapper';
import { styles } from '../screens/CompanyLandingScreen/CompanyLandingScreen.styles';
import { formatToUSDate } from 'src/helpers/dateHelper';
import { formatAddressToString } from 'src/helpers/addressHelper';
import { Address } from '@typeRoots/common/address';

interface CompanyDetailsProps {
  company: {
    companyName?: string;
    dba?: string;
    dateBusinessStarted?: string;
    dotNumber?: string;
    mcNumber?: string;
    garagingAddress?: Address;
    mailingAddress?: Address;
    twoYearsPreviousAuthority?: boolean;
  };
  onEdit: () => void;
}

const CompanyDetails: React.FC<CompanyDetailsProps> = ({ company, onEdit }) => {
  return (
    <View style={styles.dataContainer}>
      <View style={styles.detailsHeader}>
        <TourWrapper tourId="company-name">
          <Typography
            variant="h2"
            style={styles.companyName}
            numberOfLines={1}
            ellipsizeMode="tail">
            {company.companyName || 'No Company Name'}
          </Typography>
        </TourWrapper>
        <TourWrapper tourId="edit-company-btn">
          <Button
            type="tertiary"
            title="Edit"
            onPress={onEdit}
            size="medium"
            testID="landing-page-info-edit"
          />
        </TourWrapper>
      </View>

      <View style={styles.companyDetailsContainer}>
        <View style={styles.typeDateContainer}>
          <View style={styles.companyTypeContainer}>
            <Typography variant="title2" style={styles.companyLabel}>
              DBA
            </Typography>
            <Typography variant="title1">{company.dba || 'No DBA'}</Typography>
          </View>
          <View style={styles.companyTypeContainer}>
            <Typography variant="title2" style={styles.companyLabel}>
              Business Start Date
            </Typography>
            <Typography variant="title1">
              {company.dateBusinessStarted
                ? formatToUSDate(company.dateBusinessStarted)
                : 'Not Provided'}
            </Typography>
          </View>
        </View>
      </View>

      <View style={styles.dotMcContainer}>
        <View style={styles.dotNumberContainer}>
          <Typography variant="title2" style={styles.dotNumberLable}>
            DOT
          </Typography>
          <Typography variant="title1">{company.dotNumber || 'N/A'}</Typography>
        </View>
        <View style={styles.mcNumberContainer}>
          <Typography variant="title2" style={styles.mcNumberLabel}>
            MC
          </Typography>
          <Typography variant="title1">{company.mcNumber || 'N/A'}</Typography>
        </View>
      </View>

      <View style={styles.garagingAddressContainer}>
        <Typography variant="title2" style={styles.garagingAddressLabel}>
          Garaging Address
        </Typography>
        <Typography variant="title1">
          {formatAddressToString(company.garagingAddress as Address) || 'No Garaging Address'}
        </Typography>
      </View>

      <View style={styles.mailingAddressContainer}>
        <Typography variant="title2" style={styles.mailingAddressLabel}>
          Mailing Address
        </Typography>
        <Typography variant="title1">
          {formatAddressToString(company.mailingAddress as Address) || 'No Mailing Address'}
        </Typography>
      </View>

      <View style={styles.prevAuthorityContainer}>
        <Checkbox active={!!company.twoYearsPreviousAuthority} disabled onChange={() => {}} />
        <Typography variant="title1">Previous Authority</Typography>
      </View>
    </View>
  );
};

export default CompanyDetails;
